<!-- @format -->

<div
	id="pdp-stylitics-component"
	class="hmf-mt-0"
	[class.hmf-mb-l]="showHeader()"
	[class.hmf-mb-m-xl]="showHeader()">
	@if (showHeader()) {
		<div id="stylitics-header-container">
			<h2 class="stylitics-header description-header hmf-flex-grow">Complete The Set</h2>
			<hr />
		</div>
	}
	<div id="pdp-stylitics-target"></div>
</div>
